import { IconProps } from '@phosphor-icons/react';
import { useTheme } from 'styled-components';

import { Color } from '@tmh-website/shared/colors';

import * as Styled from './ShoppingCartSimpleWithIndicator.styles';

export interface ShoppingCartSimpleWithIndicatorProps extends IconProps {
  amount: number;
}

const ShoppingCartSimpleWithIndicator = ({ color, size, amount }: ShoppingCartSimpleWithIndicatorProps) => {
  const theme = useTheme();

  const amountDigits = amount.toString().length;
  const characterWidth = 140;
  const textWidth = characterWidth * (amountDigits === 0 ? 1 : amountDigits);

  return (
    <svg
      viewBox='-40 -40 860 860'
      fill='currentColor'
      style={{ overflow: 'visible', color, width: size, height: size }}>
      <mask id='shopping-cart-simple-indicator'>
        <Styled.RectWithTransition $isFadeOut={amount === 0} x='0' y='0' width='780' height='780' fill='white' />
        <Styled.RectWithTransition
          $isFadeOut={amount === 0}
          x={520 + characterWidth - textWidth}
          y='-10'
          width={360 - characterWidth + textWidth}
          height='360'
          rx='180'
          fill='black'
          transform={`scale(${amount > 0 ? 1 : 0})`}
        />
      </mask>
      <Styled.RectWithTransition
        $isFadeOut={amount === 0}
        x={550 + characterWidth - textWidth}
        y='20'
        width={300 - characterWidth + textWidth}
        height='300'
        rx='150'
        fill={theme.color[Color.Blue_500_Ultramarine]}
        transform={`scale(${amount > 0 ? 1 : 0})`}
      />
      <Styled.Count
        $isFadeOut={amount === 0}
        x={700 + characterWidth / 2 - textWidth / 2}
        y='250'
        color='white'
        textAnchor='middle'
        transform={`scale(${amount > 0 ? 1 : 0})`}>
        {amount === 0 ? 1 : amount}
      </Styled.Count>

      <g mask='url(#shopping-cart-simple-indicator)'>
        <path d='m270 630c16.569 0 30-13.431 30-30s-13.431-30-30-30-30 13.431-30 30 13.431 30 30 30z' />
        <path d='m540 630c16.569 0 30-13.431 30-30s-13.431-30-30-30-30 13.431-30 30 13.431 30 30 30z' />
        <path d='m255 240h75v-30h-45c-16.57 0-30 13.43-30 30z' />
        <path d='m566.62 540h-324.33l-60-360h-42.29v-30h67.71l60 360h275.67l55.64-215.74c2.79-13.28-.48-26.94-9.01-37.51-8.58-10.64-21.35-16.75-35.03-16.75h-245.61v-30h245.61c22.79 0 44.07 10.17 58.38 27.92 14.31 17.74 19.75 40.69 14.92 62.97l-.14.57-61.52 238.55z' />
        <path d='m90 180h90v-30h-60c-16.57 0-30 13.43-30 30z' />
      </g>
    </svg>
  );
};

export default ShoppingCartSimpleWithIndicator;
